import React from "react";
import { Tooltip } from "antd";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import InfoIcon from "../../../assets/Info_Icon.svg";
import { simpleKFormatterOnly } from "../../../redux/constants";

const NewTicket = ({ totalsTicketwidget }) => {
  //It formats big numbers by applying K

  return totalsTicketwidget?.data ? (
    <div className="row">
      <div className="col-12 col-md-3 pr-0">
        <div className="portlet1 p-0 h-100">
          <div className="mb-15 p-15 pb-0 text-center">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data[0]?.text}
              <Tooltip
                title="This count shows the number of tickets created in the selected duration."
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
                {/* <i className="fa fa-question-circle ml-1" /> */}
              </Tooltip>
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={totalsTicketwidget?.data[0]?.value?.toLocaleString()}
                placement="bottom"
              >
                {simpleKFormatterOnly(totalsTicketwidget?.data[0]?.value)}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data[0]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data[0]?.percent_change}%
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data[0]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
          <div className="border-top p-15 text-center">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data[1]?.text}
              <Tooltip
                title="These are mentions associated with new tickets created in the selected duration."
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
                {/* <i className="fa fa-question-circle ml-1" /> */}
              </Tooltip>
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={totalsTicketwidget?.data[1]?.value?.toLocaleString()}
                placement="bottom"
              >
                {simpleKFormatterOnly(totalsTicketwidget?.data[1]?.value)}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data[1]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data[1]?.percent_change}%
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data[1]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 pr-0">
        <div className="portlet1 p-0">
          <div className="text-center p-15 border-bottom">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data[3]?.text}
              <Tooltip
                title="These are the tickets which are either pending or closed in selected and old duration"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
                {/* <i className="fa fa-question-circle ml-1" /> */}
              </Tooltip>
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={totalsTicketwidget?.data[3]?.value?.toLocaleString()}
                placement="bottom"
              >
                {simpleKFormatterOnly(totalsTicketwidget?.data[3]?.value)}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data[3]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data[3]?.percent_change}%
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data[3]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 border-right">
              <div className="p-15 text-center">
                <div className="wm-chart-card-title">
                  {totalsTicketwidget?.data[3]?.data[0]?.text}
                </div>
                <div className="wm-chart-card-value">
                  <Tooltip
                    title={totalsTicketwidget?.data[3]?.data[0]?.value?.toLocaleString()}
                    placement="bottom"
                  >
                    {simpleKFormatterOnly(
                      totalsTicketwidget?.data[3]?.data[0]?.value
                    )}
                  </Tooltip>
                  <span
                    className={`font-size12 font-weight400 ml-1 ${
                      totalsTicketwidget?.data[3]?.data[0]?.percent_change > 0
                        ? "positive"
                        : "error"
                    }`}
                  >
                    {totalsTicketwidget?.data[3]?.data[0]?.percent_change}%
                    <i
                      className={`fa ml-1 ${
                        totalsTicketwidget?.data[3]?.data[0]?.percent_change > 0
                          ? "fa-caret-up"
                          : "fa-caret-down"
                      }`}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="p-15 text-center">
                <div className="wm-chart-card-title">
                  {totalsTicketwidget?.data[3]?.data[1]?.text}
                </div>
                <div className="wm-chart-card-value">
                  <Tooltip
                    title={totalsTicketwidget?.data[3]?.data[1]?.value?.toLocaleString()}
                    placement="bottom"
                  >
                    {simpleKFormatterOnly(
                      totalsTicketwidget?.data[3]?.data[1]?.value
                    )}
                  </Tooltip>
                  <span
                    className={`font-size12 font-weight400 ml-1 ${
                      totalsTicketwidget?.data[3]?.data[1]?.percent_change > 0
                        ? "positive"
                        : "error"
                    }`}
                  >
                    {totalsTicketwidget?.data[3]?.data[1]?.percent_change}%
                    <i
                      className={`fa ml-1 ${
                        totalsTicketwidget?.data[3]?.data[1]?.percent_change > 0
                          ? "fa-caret-up"
                          : "fa-caret-down"
                      }`}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="portlet1 border text-center d-flex align-items-center h-100">
          <div className="w-100">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data[2]?.text}
              {/* <Tooltip 
                                title="This count show the number of tickets created in the selected duration." 
                                placement='bottom'
                                >
                                <i className='fa fa-question-circle ml-1'/>
                                </Tooltip> */}
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={totalsTicketwidget?.data[2]?.value?.toLocaleString()}
                placement="bottom"
              >
                {simpleKFormatterOnly(totalsTicketwidget?.data[2]?.value)}
              </Tooltip>
            </div>
            <div
              className={`${
                totalsTicketwidget?.data[2]?.percent_change > 0
                  ? "positive"
                  : "error"
              }`}
            >
              {totalsTicketwidget?.data[2]?.percent_change}%
              <i
                className={`fa ${
                  totalsTicketwidget?.data[2]?.percent_change > 0
                    ? "fa-caret-up"
                    : "fa-caret-down"
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="portlet1 text-center">
      <img
        alt="no data"
        src={somethingWentWrong}
        style={{ maxWidth: "100%", minWidth: "20rem", marginTop: "1.5rem" }}
      />
      <p className="mt-15 text_regular-gray">No Data Found</p>
    </div>
  );
};

export default NewTicket;
